import NextImage from 'next/image';

const customLoader = ({ src }) => src;

export default function ImageNext(props) {
  return <NextImage {...props} loader={customLoader} />;
}
